export default __webpack_public_path__ + "static/media/cow.5b6a55f3.png";